module.exports = __webpack_public_path__ + "img/7.7e4fcd73.jpg";